// START_FAILED, RFA17, duplicate from API, grp.ts
const bankIdErrorMessages = {
  sameDevice: 'Du verkar inte ha BankID-appen/programmet. Installera den och skaffa ett BankID hos din bank.',
  otherDevice: 'Misslyckades att läsa av QR-koden. Starta BankID-appen och läs av QR-koden.',
};

export default bankIdErrorMessages;
